/**
 * explanation-modal.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";

import { GraphEdge, GraphNode, StandardGraph } from "../graphs/graph";

/**
 * A modal context containing a graph to display.
 */
export class ExplanationContext extends BSModalContext
{
  public explanation : StandardGraph;
}

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Step Explanation
    </h4>
  </div>

  <force-directed-graph [graph]="explanation"></force-directed-graph>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      (click)="dialog.close()">
      OK
    </button>
  </div>
  `,
  styles: []
})
export class ExplanationModalComponent
  implements ModalComponent<ExplanationContext>
{
  private explanation : StandardGraph;

  constructor (public dialog : DialogRef<ExplanationContext>)
  {
    this.explanation = dialog.context.explanation;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/debug/explanation-modal.component.ts